import * as React from 'react';
import { SVGProps } from 'react';

const IconCloseSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m2.164 9.156.686.694L6 6.7l3.15 3.15.7-.7L6.7 6l3.15-3.15-.707-.707L6 5.3 2.85 2.15l-.701.699 3.152 3.152-3.138 3.154z" />
  </svg>
);
export default IconCloseSizeXs;
